import { CapoPlugin } from "/root/injective/injective-bridge/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];